import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-15a60f6c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "LogicalReasoning2DQuestionContainer bothCenter wd100"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-size": "18px",
    "font-weight": "bold"
  },
  class: "pd16"
}, "题面", -1));
const _hoisted_3 = {
  class: "leftCenter question-content-container"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://cdn.waityou.online/5f3df381-d8fe-9c2b-96e0-e65847037ca6.png",
  style: {
    "width": "80px"
  }
}, null, -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://cdn.waityou.online/5f3df381-d8fe-9c2b-96e0-e65847037ca6.png",
  style: {
    "width": "80px"
  }
}, null, -1));
const _hoisted_6 = {
  key: 1,
  style: {
    "height": "100px",
    "width": "1px",
    "background-color": "gray"
  }
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-size": "18px",
    "font-weight": "bold"
  },
  class: "pd16"
}, "选项", -1));
const _hoisted_8 = {
  class: "grid grid-cols-4 gap-2.5 w-full text-2xl font-bold"
};
const _hoisted_9 = {
  class: "flex items-center"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LogicalReasoning2DImg = _resolveComponent("LogicalReasoning2DImg");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse($props.question.questionField), (q, qi) => {
    return _openBlock(), _createElementBlock("div", {
      class: "bothCenter logical-reasoning2DImg-continer",
      key: `q_${qi}`
    }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(q, (subQ, subIndex) => {
      return _openBlock(), _createBlock(_component_LogicalReasoning2DImg, {
        key: `subQ_${subIndex}`,
        imgData: subQ
      }, null, 8, ["imgData"]);
    }), 128)), qi == 2 ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_hoisted_4, _hoisted_5], 64)) : _createCommentVNode("", true), qi < 2 ? (_openBlock(), _createElementBlock("div", _hoisted_6)) : _createCommentVNode("", true)]);
  }), 128))]), _hoisted_7, _createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse($props.question.optionField), (op, opIndex) => {
    return _openBlock(), _createElementBlock("div", {
      key: `op_${opIndex}`,
      class: "bg-gray-50 flex flex-col items-center p-2"
    }, [_createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(op, (subOp, subOpIndex) => {
      return _openBlock(), _createBlock(_component_LogicalReasoning2DImg, {
        key: `subOp_${subOpIndex}`,
        imgData: subOp
      }, null, 8, ["imgData"]);
    }), 128))]), _createElementVNode("span", null, _toDisplayString($data.letters[opIndex]), 1)]);
  }), 128))])]);
}